
import { API_BASE_URL } from '../config';



// Enhanced API Service with update and delete methods
class ApiService {
  constructor() {
  this.baseURL = API_BASE_URL;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    


    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    // Handle FormData (for file uploads) - don't set Content-Type
    if (options.body instanceof FormData) {
      delete config.headers['Content-Type'];
    } else if (options.body) {
      config.body = JSON.stringify(options.body);
    }

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP ${response.status}: ${errorText || response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  // GET request
  async get(endpoint) {
    return this.request(endpoint, { method: 'GET' });
  }

  // POST request
  async post(endpoint, data) {
    return this.request(endpoint, { 
      method: 'POST', 
      body: data 
    });
  }

  // PUT request
  async put(endpoint, data) {
    return this.request(endpoint, { 
      method: 'PUT', 
      body: data 
    });
  }

  // DELETE request
  async delete(endpoint) {
    return this.request(endpoint, { method: 'DELETE' });
  }

  // PATCH request
  async patch(endpoint, data) {
    return this.request(endpoint, { 
      method: 'PATCH', 
      body: data 
    });
  }

  // ===== EVENT SPECIFIC METHODS =====
  async getAllEvents() {
    return this.get('event');
  }
  async getEvent(id) {
    return this.get(`event/${id}`);
  }
  async createEvent(eventData, bannerFile = null) {
    const formData = new FormData();
    Object.keys(eventData).forEach(key => formData.append(key, eventData[key]));
    if (bannerFile) formData.append('banner', bannerFile);
    return this.request('event', {
      method: 'POST',
      body: formData,
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
  }
  async updateEvent(id, eventData, bannerFile = null) {
    const formData = new FormData();
    Object.keys(eventData).forEach(key => formData.append(key, eventData[key]));
    if (bannerFile) formData.append('banner', bannerFile);
    return this.request(`event/${id}`, {
      method: 'PUT',
      body: formData,
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
  }
  async deleteEvent(id) {
    return this.request(`event/${id}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
  }
  async getOrganizerEvents() {
    return this.request('organizer/dashboard', {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
  }
  // ===== AUTH METHODS =====
  async signup(userData) {
    return this.post('auth/signup', userData);
  }
  async signin(credentials) {
    return this.post('auth/signin', credentials);
  }
  // ===== REGISTRATION METHODS =====
  async registerForEvent(eventId, registrationData) {
    return this.post(`event/${eventId}/register`, registrationData);
  }
  async submitTalkProposal(eventId, proposalData) {
    return this.post(`event/${eventId}/call-for-papers`, proposalData);
  }
}

// Create singleton instance
const apiService = new ApiService();

export default apiService;
